interface DayProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  disabled: boolean;
}

export default function Day({ children, className, onClick, disabled }: DayProps): JSX.Element {
  return (
    <div className="calendar-day-box">
      <button
        className={`calendar-day ${className}`}
        onClick={onClick}
        disabled={disabled}
        type="button"
      >
        <div className="calendar-day-content">{children}</div>
      </button>
    </div>
  );
}

const defaultProps: Pick<DayProps, 'className' | 'onClick'> = {
  className: undefined,
  onClick: undefined,
};

Day.defaultProps = defaultProps;
